import SimpleContainer from './SimpleContainer'
import { ContainerType } from './ContainerType'
import OverlayContainer from './OverlayContainer'
import DockedBottomContainer from './DockedBottomContainer'
import DockedRightContainer from './DockedRightContainer'
import StickyContainer from './StickyContainer'
import DockedBottomRight from './DockedBottomRightContainer'
import Logger from '../Log'
import HeadlinerContainer from './HeadlinerContainer'

const Log = Logger.for('containers')

export function getContainer (type) {
  if (!(type instanceof ContainerType)) throw Error('getContainer called for non ContainerType object: ' + type)

  Log.debug('Looking for container ' + type)
  switch (type.toString()) {
    case 'SIMPLE':
      return new SimpleContainer()
    case 'OVERLAY':
      return new OverlayContainer()
    case 'DOCKED_BOTTOM':
      return new DockedBottomContainer()
    case 'DOCKED_RIGHT':
      return new DockedRightContainer()
    case 'STICKY':
      return new StickyContainer()
    case 'DOCKED_BR':
      return new DockedBottomRight()
    case 'HEADLINER':
      return new HeadlinerContainer()
    default:
      throw Error('Unknown container type: ' + type)
  }
}
